<template>
  <div class="question-container">
    <van-cell-group v-if="list.length > 0">
      <van-cell v-for="(item, index) in list" :key="index" :title="item" @click="doChoose(item)" center> </van-cell>
    </van-cell-group>
    <div class="search">
      <van-search
        v-model="searchTxt"
        show-action
        shape="round"
        background="#fff"
        placeholder="请输入您的问题"
        @input="getQuestion"
      >
        <template #action>
          <van-button round type="info" size="small" @click="doSend">发送</van-button>
        </template>
      </van-search>
    </div>
  </div>
</template>
<script>
import { getQuestions } from "@/api/business";
// import { debounce } from "throttle-debounce";
export default {
  data() {
    return {
      searchTxt: "",
      list: []
    };
  },
  methods: {
    // searchDebounce: debounce(500, function(val) {
    //   if (val) {
    //     this.getQuestion(val);
    //   }
    // }),
    async getQuestion(val) {
      let { status, resultData } = await getQuestions({ word: val });
      if (status === "complete") {
        this.list = resultData;
      }
    },
    doChoose(item) {
      this.$emit("send-done", item);
    },
    doSend() {
      this.$emit("send-done", this.searchTxt);
    }
  }
};
</script>
